import { useEffect, useRef } from 'react';
import { getCsrfToken } from '../lib/csrf.js';

// Posts a partial state patch to /api/buy_draft, debounced.
// `path` is a dot-notated key path, e.g. "group.buyer" or "individual.role".
// Pass `enabled=false` to skip until you're ready (e.g. on first render).
export function useDraftAutosave(path, value, { enabled = true, delay = 600 } = {}) {
  const timer = useRef(null);
  const lastSent = useRef(undefined);

  useEffect(() => {
    if (!enabled) return;
    const serialized = JSON.stringify(value);
    if (serialized === lastSent.current) return;

    if (timer.current) clearTimeout(timer.current);
    timer.current = setTimeout(() => {
      lastSent.current = serialized;
      const csrf = getCsrfToken();
      const patch = setDeep({}, path, value);
      fetch('/api/buy_draft/merge', {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': csrf },
        credentials: 'same-origin',
        body: JSON.stringify({ patch }),
      }).catch(() => {});
    }, delay);

    return () => { if (timer.current) clearTimeout(timer.current); };
  }, [enabled, path, JSON.stringify(value), delay]);
}

function setDeep(obj, path, value) {
  const keys = path.split('.');
  let cursor = obj;
  for (let i = 0; i < keys.length - 1; i++) {
    cursor[keys[i]] = cursor[keys[i]] || {};
    cursor = cursor[keys[i]];
  }
  cursor[keys[keys.length - 1]] = value;
  return obj;
}
